import { PACKAGING_HISTORY_LIST_FAIL, PACKAGING_HISTORY_LIST_REQUEST, PACKAGING_HISTORY_LIST_SUCCESS } from "../constats/packaging_history.constant";

export const packagingHistoryListReducer = (state={}, action) => {
    switch (action.type) {
        case PACKAGING_HISTORY_LIST_REQUEST:
            return {
                loading: true
            };
        case PACKAGING_HISTORY_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case PACKAGING_HISTORY_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}